import * as GTM_EVENTS from "./gtmEvents";
import trackGtmEvent from "./trackGtmEvent";

export { GTM_EVENTS, trackGtmEvent };
